// Ported from CarbonEngine (MIT, (c) 2026 CCP Games) - https://github.com/carbonengine/trinity
//   trinityaudioapi/include/ITr2AudGeometry.h
// Generated by format-carbon carbon-class --emit. Verify against trinityAudioApi/Tr2AudGeometryData.json.
import { type } from "@carbonenginejs/runtime-utils/schema";
import { CjsModel } from "@carbonenginejs/runtime-utils/model";
import { vec3 } from "@carbonenginejs/runtime-utils/vec3";

/** Tr2AudGeometryData (trinityAudioApi) - generated from schema shapeHash 92764465.... */
@type.define({ className: "Tr2AudGeometryData", family: "trinityAudioApi" })
export class Tr2AudGeometryData extends CjsModel
{

  /** m_vertices (std::vector<Vector3>) */
  @type.list("Vector3")
  vertices = [];

  /** m_indices (std::vector<uint32_t>) */
  @type.list("uint32_t")
  indices = [];

  /** m_minBounds (Vector3) */
  @type.vec3
  minBounds = vec3.create();

  /** m_maxBounds (Vector3) */
  @type.vec3
  maxBounds = vec3.create();

}
